<template>
  <div>
    <custom-actions show-back>
      <!-- <template #header>
        <el-button type="primary" @click="exportPageToPdf">打印</el-button>
      </template> -->
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="140px">
        <el-col :span="12">
          <el-form-item prop="payerName" label="付款方">
            {{ formData.payerName || "--" }}
          </el-form-item>
          <el-form-item prop="userName" label="供应商名称">
            {{ formData.userName || "--" }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="formData.depositType === '1'" prop="contractNumber" label="合同号">
            {{ formData.contractNumber || "--" }}
          </el-form-item>
          <el-form-item prop="depositNumber" label="流水凭证单号">
            {{ formData.depositNumber || "" }}
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item prop="depositStatus" label="工单状态">
            <el-tag type="warning" v-if="formData.depositStatus == '1'">审批中</el-tag>
            <el-tag type="success" v-if="formData.depositStatus == '2'">审批通过</el-tag>
            <el-tag type="danger" v-if="formData.depositStatus == '3'">驳回作废</el-tag>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="depositType" label="资金类型">
            <!-- {{ formData.depositType == '1' ? '充值' : formData.depositType == '2' ? '退还' : '' }} -->
            {{ transactionTypeMap.get(formData.transactionType) }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="depositType" label="操作类型">
            <!-- {{ formData.depositType == '1' ? '充值' : formData.depositType == '2' ? '退还' : '' }} -->
            {{ depositTypeMap.get(formData.depositType) }}
          </el-form-item>
        </el-col>
        <template v-if="!(['1', '2'].includes(formData.depositType) && formData.approvalStatus === '2')">
          <el-col :span="12">
            <el-form-item prop="depositChange" label="金额(元)">
              {{ formData.depositChange || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="depositChange" label="日期">
              {{ formData.transferDate || "" }}
            </el-form-item>
          </el-col>
        </template>
<!--        退还-->
        <template v-if="formData.depositType === '2'">
          <el-col :span="12">
            <el-form-item prop="fkBank" label="收款银行">
              {{ formData.fkBank || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="receivingBank" label="付款银行">
              {{ formData.receivingBank || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="receivingAccount" label="付款账号">
              {{ formData.receivingAccount || "" }}
            </el-form-item>
          </el-col>
        </template>
        <template v-else>
          <el-col :span="12">
            <el-form-item prop="fkBank" label="付款银行">
              {{ formData.fkBank || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="receivingBank" label="收款银行">
              {{ formData.receivingBank || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="receivingAccount" label="收款账号">
              {{ formData.receivingAccount || "" }}
            </el-form-item>
          </el-col>
        </template>
        <el-col :span="12">
          <el-form-item prop="ctime" label="创建时间">
            {{ formData.ctime || "" }}
          </el-form-item>
        </el-col>

        <el-col v-if="formData.depositType === '1'" :span="24">
          <el-form-item label="备注" prop="remark">
            <span style="white-space: pre-wrap; overflow-wrap: anywhere;">{{ formData.remark || '' }}</span>
          </el-form-item>
        </el-col>

        <el-row v-if="formData.fileList && formData.fileList.length > 0">
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <file-upload readonly v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="" label="审批记录">
              <el-timeline :reverse="true" placement="top">
                <el-timeline-item placement="top" v-for="(item, index) of formData.recordList" :key="index"
                  :timestamp="item.approvalTime || '--'">
                  <el-card>
                    <el-row>
                      <el-col :span="24">
                        审批状态：
                        <el-tag v-if="item.approvalStatus == '1'">待审批</el-tag>
                        <el-tag type="success" v-if="item.approvalStatus == '2'">审批通过</el-tag>
                        <el-tag type="danger" v-if="item.approvalStatus == '3'">审批驳回</el-tag>
                      </el-col>
                      <el-col :span="24">
                        审批名称：{{ item.approvalName || '--' }} </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        审批意见：{{ item.approvalComments || '--' }}
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">审批人：{{ item.approver || '--' }}</el-col>
                      <el-col :span="12">审批时间：{{ item.submitTime || '--' }}</el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">提交人：{{ item.submitter || '--' }}</el-col>
                      <el-col :span="12">提交时间：{{ item.submitTime || '--' }}</el-col>
                    </el-row>
                    <el-row v-if="item.fileList && item.fileList.length > 0">
                      <el-col :span="24">
                        附件：
                        <file-upload readonly v-model="item.fileList"></file-upload>
                      </el-col>
                    </el-row>
                  </el-card>

                </el-timeline-item>
              </el-timeline>

            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { depositType, ycTransactionType } from '@/utils/dict'
export default {
  name: 'BondRecordDetail3',
  data() {
    return {
      depositTypeMap: depositType,
      transactionTypeMap: ycTransactionType,
      formData: {
        depositNumber: '', // 订单编号
        contractNumber: '', // 合同号
        remark: '', // 付款备注
        userId: '', // 关联客户ID，关联客户表
        depositStatus: '', // 工单状态，1审批中2审批通过3作废
        approvalStatus: '', // 审批状态，1待审批，2审批通过，3审批驳回
        depositType: '', // 类型1充值2退还3保证金转货款
        depositChange: '', // 充值/退还金额
        transactionType: '', // 金额类型 1 保证金 2 货款
        transferDate: '', // 转账日期
        receivingBank: '', // 收款银行
        receivingAccount: '', // 收款账号
        fileList: [] // 附件列表
      }
    }
  },
  created() {
    if (this.depositId) {
      this.loadData()
    }
  },
  computed: {
    depositId() {
      return this.$route.query.depositId
    },
    menu() {
      return this.$route.matched[this.$route.matched.length - 1]
    }
  },
  methods: {
    // async exportPageToPdf() {
    //   // 1. 拿到你页面真实内容
    //   const originalDom = document.getElementById('print-content')

    //   // 2. 克隆一份
    //   const cloneDom = originalDom.cloneNode(true)

    //   // 3. 给 shoufa-form 设置 600px 宽度（只改克隆体！）
    //   const shoufaForm = cloneDom.querySelector('.shoufa-form')
    //   if (shoufaForm) {
    //     shoufaForm.style.width = '600px'
    //     shoufaForm.style.maxWidth = '600px'
    //     shoufaForm.style.boxSizing = 'border-box'
    //   }

    //   // 4. 给克隆体设置 A4 尺寸
    //   cloneDom.style.width = '210mm'
    //   cloneDom.style.background = '#fff'
    //   cloneDom.style.padding = '15px'
    //   cloneDom.style.opacity = '1' // 关键：完全不透明
    //   cloneDom.style.boxSizing = 'border-box'

    //   // ==================== 关键 ====================
    //   // 不隐藏！不移除！不透明！直接临时放页面上！
    //   // 导出完立刻删掉！用户几乎看不见！
    //   // ==================================================
    //   // 3. 把所有子元素全部强制不透明
    //   const allChild = cloneDom.querySelectorAll('*')
    //   allChild.forEach(el => {
    //     el.style.opacity = '1'
    //     el.style.background = el.style.background || '#fff'
    //   })

    //   document.body.appendChild(cloneDom)

    //   const opt = {
    //     margin: 0,
    //     filename: this.menu.meta.title + '.pdf',
    //     image: { type: 'jpeg', quality: 1 },
    //     // 关键配置防截断
    //     html2canvas: {
    //       scale: 1.5,
    //       useCORS: true,
    //       logging: false
    //     },
    //     jsPDF: {
    //       unit: 'mm',
    //       format: 'a4',
    //       orientation: 'portrait'
    //     }
    //   }
    //   await html2pdf().set(opt).from(cloneDom).save()

    //   // 导出完马上删除
    //   document.body.removeChild(cloneDom)
    // },
    loadData() {
      this.$axios.get(this.$apis.yxcBondRecord.selectYxcUserDepositNewByDepositId, {
        params: { depositId: this.depositId }
      }).then(res => {
        res.fileList = res.fileList ? res.fileList : []
        res.recordList = res.recordList ? res.recordList : []
        this.formData = res
      })
    }

  }
}
</script>

<style scoped lang="scss">
.shoufa-form {
  width: 800px;
}

::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
